import React, { useEffect } from 'react'
import { ThemeProvider, createTheme, BreakpointOverrides, } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { OwnProps } from '../../Utils/Types';
import type { } from '@mui/x-data-grid/themeAugmentation';

import { selectAuth } from '../../Pages/Login/store/login.Slice'
import { useAppSelector } from '../../hooks'

import { useNavigate } from 'react-router-dom';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true; // removes the `xs` breakpoint
    sm: true;
    md: true;
    lg: true;
    xl: true;
    pl: true; // adds the `mobile` breakpoint
    pp: true;
    il: true;
    ip: true;
  }
}


declare module '@mui/material/styles/createTheme' {
  interface Theme {
    appDrawer: {
      width: React.CSSProperties['width']
      breakpoint: BreakpointOverrides
    }
  }
  // allow configuration using `createMuiTheme`
  interface ThemeOptions {
    appDrawer?: {
      width?: React.CSSProperties['width']
      breakpoint?: BreakpointOverrides
    }
  }
}

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
  typography: {
    fontFamily: [
      "Nunito",
      "sans-serif"
    ].join(",")
  },
 
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      pl: 926,
      pp: 428,
      il: 1194,
      ip: 834

    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#000000',
          },
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#000000',
          },
        }
      }
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {

          border: 'none'
        },
        cell: {
          border: 'none'
        },
        footerContainer: {
          border: 'none'
        },
        columnHeaders: {
          borderBottom: 'none !important'
        },
        iconSeparator: {
          display: 'none'
        },
        virtualScroller: {
          width: '20px'
        },
        columnHeaderTitle: {
          fontSize: 20
        },
        cellContent: {
          fontSize: 16
        }

      }
    },




  }
});



const PrivateLayout: React.FC<OwnProps> = (props: OwnProps) => {

  const navigate = useNavigate()
  const auth = useAppSelector(selectAuth);
  useEffect(() => {
    if (!auth.isloggedIn) {
      navigate('/', { replace: true })
    }
  }, [])

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />

      {props.children}
    </ThemeProvider>
  )
}

export default PrivateLayout